import Abhilash_Reddy_Sandi_Resume from '../assets/pdf/Abhilash_Reddy_Sandi_Resume.pdf'
import introImg from '../assets/introPic-min.jpg';

export const headerData = {
    name: 'Abhilash Sandi',
    title: "Senior Software Engineer",
    desciption:"Building bridges between pixels and people, with innovation at the core. Full stack web development expertise tailored to elevate your online presence.",
    image: introImg,
    resumePdf: Abhilash_Reddy_Sandi_Resume
}
